import React, { useState, useEffect, useCallback, useMemo } from 'react';
import {
  formatDateMonth,
  KTSVG,
  LoadingGrid,
} from '../../../../../_mexablock/helpers';
import { CreateModal } from '../_modals/CreateModal';
import { CreateModalManual } from '../_modals/UpdateModal';
import { TableList } from '../../../../../_mexablock/helpers/components/TableList';
import { MenuComponent } from '../../../../../_mexablock/assets/ts/components';
import { useGetAll } from '../hooks/AsignacionHook';
import { downloadPackageReportPDF } from '../../../../service/inventario/entrada&salidas';
import 'flatpickr/dist/flatpickr.min.css';
import { Filter } from '../../../reportes/estudiantes/_modals/Filter';
import { downloadAsignacionReportPDF } from '../../../../service/inventario/asignacion';

const View: React.FC = () => {
  const [loadingView, setLoadingView] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showModalManual, setShowModalManual] = useState(false);
  const [reloadKey, setReloadKey] = useState(Math.random());
  const [initFilterValues, setInitFilterValues] = useState({
    init_date: '',
    end_date: '',
  });
  const { data, loadingRequest } = useGetAll(reloadKey, initFilterValues);

  useEffect(() => {
    const timer = setTimeout(() => {
      MenuComponent.reinitialization();
    }, 300);

    return () => clearTimeout(timer);
  }, [data, showModal, showModalManual]);

  useEffect(() => {
    if (loadingRequest > 0) setLoadingView(false);
  }, [loadingRequest]);

  const columns = useMemo(
    () => [
      {
        id: 'createdAt',
        name: <div className="fw-bolder text-muted me-5">Fecha</div>,
        selector: (row: any) => formatDateMonth(row.createdAt),
        sortable: true,
      },
      {
        id: 'ID',
        name: <div className="fw-bolder text-muted me-5">Folio</div>,
        selector: (row: any) => `ASG${String(row.id).padStart(4, '0')}`,
        sortable: true,
      },
      {
        id: 'Zona',
        name: <div className="fw-bolder text-muted me-5">Zona Asign.</div>,
        selector: (row: any) => row.zona?.name,
        sortable: true,
      },
      {
        id: 'Cant',
        name: <div className="fw-bolder text-muted me-5">Cant.</div>,
        selector: (row: any) => Number(row.total_amount),
        sortable: true,
      },
      {
        id: 'Responsable',
        name: <div className="fw-bolder text-muted me-5">Responsable</div>,
        selector: (row: any) => row.zona?.user?.first_name,
        cell: (row: any) => {
          if (row.zona?.has_responsible === 1) {
            const c = row.zona?.user;
            return (
              <div>
                {c
                  ? `${c.first_name || ''} ${c.father_last_name || ''}`.trim()
                  : 'Sin asignar'}
              </div>
            );
          }
          return 'Sin responsable';
        },
        sortable: true,
      },
      {
        id: 'razon',
        name: <div className="fw-bolder text-muted me-5">Razón</div>,
        selector: (row: any) => row.motive_name,
        sortable: true,
      },
      {
        id: 'usuario',
        name: <div className="fw-bolder text-muted me-5">Usuario</div>,
        selector: (row: any) => row.creator.first_name,
        cell: (row: any) => {
          const user = row.creator;
          if (!user) return 'Sin responsable';
          return `${user.first_name || ''} ${user.father_last_name || ''} ${
            user.mother_last_name || ''
          }`.trim();
        },
        sortable: true,
      },
      {
        id: 'acciones',
        name: <div className="fw-bolder text-muted me-5"></div>,
        cell: (row: any) => dropdownRender(row),
      },
    ],
    []
  );

  const handleDownload = useCallback(async (row: any) => {
    if (!row?.id) return;
    try {
      await downloadAsignacionReportPDF(row.id);
    } catch (err) {
      console.error('Error al descargar el comprobante:', err);
    }
  }, []);

  const dropdownRender = useCallback(
    (row: any) => (
      <div className="d-flex justify-content-end flex-shrink-0">
        <a
          data-kt-menu="true"
          className="btn btn-light btn-active-light-primary btn-sm"
          data-kt-menu-trigger="click"
          data-kt-menu-placement="bottom-end"
        >
          Acciones
          <span className="svg-icon svg-icon-5 m-0">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="mh-50px"
            >
              <path
                d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z"
                fill="currentColor"
              ></path>
            </svg>
          </span>
        </a>

        <div
          className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-150px py-4"
          data-kt-menu="true"
        >
          <div className="menu-item px-3">
            <a
              className="menu-link px-3"
              onClick={(e) => {
                e.preventDefault();
                handleDownload(row);
              }}
            >
              Descargar comprobante
            </a>
          </div>
        </div>
      </div>
    ),
    [handleDownload]
  );

  const openModal = useCallback(() => setShowModal(true), []);
  const openModalManual = useCallback(() => setShowModalManual(true), []);

  const handleFilter = (values: any) => {
    setInitFilterValues({
      init_date: values.init_date || '',
      end_date: values.end_date || '',
    });
  };

  const handleFilterClean = () => {
    setInitFilterValues({
      init_date: '',
      end_date: '',
    });
  };

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xl-12">
          <div className="card card-xxl-stretch mb-5 mb-xl-12">
            <div className="card-header border-0 pt-5 d-flex justify-content-between align-items-center flex-wrap">
              <div className="flex-grow-1">
                <Filter
                  initFilterValues={initFilterValues}
                  onCleanFilter={handleFilterClean}
                  onSearchFilter={handleFilter}
                  showFilterCode={true}
                />
              </div>

              <div className="d-flex justify-content-end">
                <a
                  href="#/"
                  data-kt-menu="true"
                  className="btn btn-sm btn-light-primary"
                  data-kt-menu-trigger="click"
                  data-kt-menu-placement="bottom-end"
                >
                  <KTSVG
                    path="/media/icons/duotune/arrows/arr075.svg"
                    className="svg-icon-5 svg-icon-gray-500 me-1"
                  />
                  Asignar
                </a>

                <div
                  className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-200px py-4"
                  data-kt-menu="true"
                >
                  <div className="menu-item px-3">
                    <a className="menu-link px-3" onClick={openModalManual}>
                      Manualmente
                    </a>
                  </div>
                  <div className="menu-item px-3">
                    <a className="menu-link px-3" onClick={openModal}>
                      Selección múltiple
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {loadingView ? (
              <LoadingGrid text="Cargando..." />
            ) : (
              <TableList data={data} columns={columns} />
            )}
          </div>
        </div>
      </div>

      <CreateModal
        show={showModal}
        handleClose={(updateGrid) => {
          if (updateGrid) setReloadKey(Math.random());
          setShowModal(false);
        }}
      />
      <CreateModalManual
        show={showModalManual}
        handleClose={(updateGrid) => {
          if (updateGrid) setReloadKey(Math.random());
          setShowModalManual(false);
        }}
      />
    </>
  );
};

export { View };
